import { ApplicationConfig, EnvironmentProviders, Provider, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { provideMarkdown } from 'ngx-markdown';
import { TimeZoneService } from './shared/globalization/services/time-zone-service';
import { LoginObserverService } from './shared/authentication/login-observer.service';
import { take } from 'rxjs';

export function getBaseUrl(): string {
  return document.getElementsByTagName('base')[0].href;
}

const monacoConfig: NgxMonacoEditorConfig = {
  baseUrl: window.location.origin + '/assets/monaco/min/vs', // added due to monaco editor worker not loading issue https://github.com/microsoft/monaco-editor/issues/4778
  //baseUrl: 'assets', // configure base path for monaco editor. Starting with version 8.0.0 it defaults to './assets'. Previous releases default to '/assets'
  defaultOptions: { scrollBeyondLastLine: false }, // pass default options to be used
  onMonacoLoad: () => { } // here monaco object will be available as window.monaco use this function to extend monaco editor functionalities.
};

const providers: Array<Provider | EnvironmentProviders> = [
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes, withComponentInputBinding()),
  provideNoopAnimations(),
  provideHttpClient(withXhr(), withInterceptorsFromDi()),
  importProvidersFrom(MonacoEditorModule.forRoot(monacoConfig)),
  provideMarkdown(),
  NgbActiveModal,
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  provideAppInitializer(() => {
    const timeZoneService = inject(TimeZoneService);
    const loginObserverService = inject(LoginObserverService);
      loginObserverService.loginObserver.pipe(take(1)).subscribe(() => {
          // We invoke these services when the user logs in, so that time zones are cached and available. 
      timeZoneService.timeZones();
      timeZoneService.localTimeZone();
    });
  }),
];

export const appConfig: ApplicationConfig = { providers };
